import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { BLOCK_UNBLOCK_DATE, BLOCK_UNBLOCK_DATE_SUCCESS, BLOCK_UNBLOCK_DATE_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* blockUnblockDate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { blockDateId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/block-date/${blockDateId}/unblock`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`Block date unblocked successfully`);
      yield put({
        type: BLOCK_UNBLOCK_DATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: BLOCK_UNBLOCK_DATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: BLOCK_UNBLOCK_DATE_ERROR, payload: error });
  }
}

export function* watchblockUnblockDate() {
  yield takeEvery(BLOCK_UNBLOCK_DATE, blockUnblockDate);
}

function* blockUnblockDateSaga() {
  yield all([fork(watchblockUnblockDate)]);
}

export default blockUnblockDateSaga;
